import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { CapabilitiesService } from './capabilities.service';
import { CapabilityName } from './registry-ot.generated';

/**
 * Route guard that reads the required capability from `route.data.capability` and
 * redirects to `/not-found` when the user lacks it (the app declares that route
 * as an authenticated-but-ungated FGR-Hub-style 404 page, matching the
 * NgxPermissionsGuard `redirectTo` targets — see app.routes.ts). Class-based to
 * match every existing OT guard (functional guards are not used in this app).
 *
 *   { path: 'accounting', component: ..., canActivate: [CapabilityGuard],
 *     data: { capability: 'canViewDealAccounting' } }
 */
@Injectable({ providedIn: 'root' })
export class CapabilityGuard implements CanActivate {
  constructor(private capabilities: CapabilitiesService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const name = route.data['capability'] as CapabilityName | undefined;
    return !name || this.capabilities.check(name)
      ? true
      : this.router.parseUrl('/not-found');
  }
}
